<template>
  <div class="content content--sub">
    <div class="bg-img">
      <img src="../assets/images/hero-pp.jpg">
    </div>

    <MyHeader :breadcrumbItems="[

        {
          name: 'Privacy Policy',
          path: this.$route.path
        },
      ]"/>

    <header class="content-header">
      <h1>Privacy policy</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- article list for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <div class="article-list-title">Table of contents</div>
        <ul>
          <li><a href="#introduction">Introduction</a></li>
          <li><a href="#storeData">Data that the app store about you</a></li>
          <li><a href="#personalData">Sharing of your Personal Data</a></li>
          <li><a href="#yourRights">Your rights</a></li>
          <li><a href="#dataSecurity">Data security and integrity</a></li>
        </ul>
      </div>
    </transition>

    <div class="container main-content">
      <div class="row">
        <div class="col-lg-3 article-list d-none d-lg-block">
          <div class="article-list-title">Table of contents</div>
          <ul>
            <li><a href="#introduction">Introduction</a></li>
            <li><a href="#storeData">Data that the app store about you</a></li>
            <li><a href="#personalData">Sharing of your Personal Data</a></li>
            <li><a href="#yourRights">Your rights</a></li>
            <li><a href="#dataSecurity">Data security and integrity</a></li>
          </ul>
        </div>
        <div class="col-lg-7 article-content">
          <h2 id="introduction">Introduction</h2>
          <p>Data protection is a key concern for Capgemini™ which has been placing this matter as a priority for long. Hence, transparency regarding the way we process the personal data we collect is a commitment for us. The information provided below intends to provide you all relevant information in relation to the collection and processing of information which may be collected through this application CAPGEMINI ENGAGE, (hereinafter, the “application”)</p>
          <p>Capgemini Services SAS (hereinafter, “we”, “us”, “our” or “Capgemini™”), acting as the Data Controller, may collect and process personal data relating to you when you use this application.</p>
          <p>All terms, used in this Privacy Policy, related to data protection and starting with a capital letter take the definitions given by Article 4 of the General Data Protection Regulation (Regulation (EU) 2016/679 “GDPR”).</p>

          <h2 id="storeData">Data that the app store about you</h2>
          <h3>Name and surname, email, role, picture, department and country</h3>
          <p>We use these data (from the Capgemini Employee Directory) to identify your user profile and show you the information you have access to. This processing is based on our legitimate interest to propose a didactic application displaying the profile of its users.<br>
            We store this information as long as you are registered user of the app.
          </p>
          <h3>Unique identifier and content you have access to</h3>
          <p>
            We use this information to gather statistics to know how the application is used and to ensure that our app is as comfortable as possible for you. This processing is based on our legitimate interest to improve the mobile app.<br>
            We store this information as long as you are registered user of the app.
          </p>
          <h3>Your device info (name and system) and log information (time of access, city and country from where you access the app and IP address)</h3>
          <p>We use this information to gather statistics, fix bug and develop new features.<br>
            This processing is based on our legitimate interest to ensure the security, maintenance and improvement of the application.<br>
            We store your device info as long as you are a registered user of the app and login data for 6 months.<br>
          </p>
          <h3>Information you provide (answers to status surveys, trivia games, and comments to contents)</h3>
          <p>
            This is the information you choose to provide when you use the various features of the application.<br>
            This processing is based on our legitimate interest to provide a didactic application that allows users to interact with each other.<br>
            We store this information as long as you are a registered user of the app.<br>
          </p>
          <h3>Information that you communicate to us via the “Contact Us” form</h3>
          <p>
            We use this information to manage your request, queries or inquiries. This processing is based on our legitimate interest to develop and maintain a professional relationship with you.<br>
            We store this information as long as you are a registered user of the app.
          </p>

          <h2 id="personalData">Sharing of your Personal Data</h2>
          <h3>1. Recipients of your Personal data at Capgemini™</h3>
          <p>Your Personal data can only be accessed by Capgemini™ authorized personnel who strictly need to access it.<br>
            Regarding the processing of your Personal data communicated through the Contact Form, only authorized personnel working in the Marketing department or other commercials working in the department in charge of the scope of your request will be able to access.<br>
            Regarding the processing of your mood optionally communicated, only the Human Resources department and the app admin team will be able to access.<br>
          </p>
          <h3>2. With other entities of the group</h3>
          <p>Capgemini™, is a global organisation. Whilst we have distinct legal entities (e.g., country subsidiaries) in many parts of the world, our internal processes and infrastructure are international in scope and nature and generally cross-country borders.<br>
            <br>
            Within the group, the following entities may have access to your Personal data:<br>
            <br>
            • Macs Poland, which is in charge of the application maintenance;<br>
            • All HR teams from all Capgemini entities.<br>
            <br>
            Capgemini™ may transfer your Personal Data to other Capgemini entities located outside of the European Economic Area. These transfers are covered by Capgemini’s Binding Corporate Rules (Capgemini BCR) which were approved by the French Data Protection Authority (the CNIL) in 2016. As a result of these BCR, wherever your personal data is processed within the group, your personal data will benefit from the same level of protection. You can access Capgemini BCR at  <a href="https://www.capgemini.com/resources/capgemini-binding-corporate-rules/" target="_blank">https://www.capgemini.com/resources/capgemini-binding-corporate-rules/</a><br>
            <br>
            Outside of the European Economic Area, the following Capgemini entities may have access to your Personal data<br>
            • Capgemini Technology Services India Limited.<br>
          </p>
          <h3>3.Third-party suppliers</h3>
          <p>
            Data is hosted by our data processor in Ireland, with main backup in Frankfurt.<br>
            Since the last up-date of this Privacy Policy, no third-party supplier can have access to your Personal data.
          </p>
          <h3>4.Judicial, public and/or governmental authorities</h3>
          <p>
            We may also be required – by law, legal process, litigation, and/or requests from public and governmental authorities within or outside your country of residence— to disclose your personal data. We may also disclose your personal data if we determine that for purposes of national security, law enforcement, or other issues of public importance, disclosure is necessary or appropriate.<br>
            We may also disclose personal information if we determine in good faith that disclosure is reasonably necessary to protect our rights and pursue available remedies, enforce our terms and conditions, investigate fraud, or protect our operations or users
          </p>
          <h2 id="yourRights">Your rights</h2>
          <p>Under applicable Data Protection Law and, notably the GDPR, you have a number of rights with regard to your personal data. Those rights are as follows:</p>
          <p>• <b>Right to Access</b> – You can ask to see what personal information Capgemini™ holds about you. In the event we cannot provide you with access to your personal information (for instance, if your personal information has been destroyed, erased or made anonymous), we will inform you of the reasons why.</p>
          <p>• <b>Correction or Deletion of Personal Information</b> – Capgemini™ works to ensure that your personal information in its possession is accurate, current and complete. If you believe that the personal information Capgemini™ holds on you is incorrect, inaccurate, incomplete or outdated, you may request the revision or correction of that information.</p>
          <p>• <b>Objection to the processing of your Personal data</b> – you have the possibility to object to the processing of your personal data including profiling, on grounds relating to your particular situation as provided by Data Protection laws.</p>
          <p>
            • <b>Limitation to the processing of your Personal data</b> – you have the right to obtain from us a restriction of processing in certain instances as listed by data protection laws.<br>
            In case of any request or complaint, please send an email to our Data Protection Officer <a href="mailto:dpofrance.fr@capgemini.com">dpofrance.fr@capgemini.com</a>.
          </p>
          <p>If you have unresolved concerns, you also have the right to complain to the competent Data Protection Authority.</p>

          <h2 id="dataSecurity">Data security and integrity</h2>
          <p>Capgemini™ has implemented appropriate technical and organizational measures to ensure an adequate level of security regarding the risk incurred and to protect your personal data against unauthorized access, disclosure, alteration or destruction.</p>
          <p>However, you should be aware that, due to the open and unsecured character of the Internet, Capgemini™ cannot be responsible for the security of transmissions of the personal data over the Internet.</p>
          <h3>Notification of changes to this Policy</h3>
          <p>This Policy was last updated on April 07th, 2020.</p>
          <p>We may periodically change this Policy to keep pace with new technologies, industry practices, and regulatory requirements, among other reasons. We expect most such changes to be minor.</p>
          <p>When we will need to make a significant change to our Privacy Policy, we will post a prominent notice on the home page of the application prior to the change becoming effective.</p>
          <p>In any case, we advise you to take a look at this Privacy Policy from time to time.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../components/general/Header'

export default {
  name: "PrivacyPolicy",
  components: { MyHeader },
  data () {
    return {
      showList: false
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Privacy Policy']);
    window._paq.push(['trackPageView']);
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
